// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:768px){.navbar[data-v-b777f726]{display:none}}@media screen and (min-width:769px){.mobile-navbar[data-v-b777f726]{display:none}}.main-content[data-v-b777f726]{padding-bottom:70px}", ""]);
// Exports
module.exports = exports;
